import { IBitDeviceInfo, IEIoTAuth, IGPSData, IWeatherData, IEIoTDeviceInfo } from "../interfaces";

class EIoTSessionVarsService {

  set DevMgrComps(data: any) {
    sessionStorage.setItem('DevMgrComps', JSON.stringify(data));
  }
  get DevMgrComps(): any {
    return sessionStorage.getItem('DevMgrComps')
      ? JSON.parse(sessionStorage.getItem('DevMgrComps') as string)
      : null;
  }


  set GPSData(data: IGPSData) {
    sessionStorage.setItem('GPSData', JSON.stringify(data));
  }
  get GPSData(): IGPSData {
    return sessionStorage.getItem('GPSData')
      ? JSON.parse(sessionStorage.getItem('GPSData') as string)
      : {};
  }
  
  
  set WeatherData(data: IWeatherData) {
    sessionStorage.setItem('WeatherData', JSON.stringify(data));
  }
  get WeatherData(): IWeatherData {
    return sessionStorage.getItem('WeatherData')
      ? JSON.parse(sessionStorage.getItem('WeatherData') as string)
      : {};
  }


  set EIoTDeviceInfo(data: IEIoTDeviceInfo) {
    sessionStorage.setItem('EIoTDeviceInfo', JSON.stringify(data));
  }
  get EIoTDeviceInfo(): IEIoTDeviceInfo {
    return sessionStorage.getItem('EIoTDeviceInfo')
      ? JSON.parse(sessionStorage.getItem('EIoTDeviceInfo') as string)
      : {};
  }
  

  set BitDeviceInfo(data: IBitDeviceInfo) {
    sessionStorage.setItem('BitDeviceInfo', JSON.stringify(data));
  }
  get BitDeviceInfo(): IBitDeviceInfo {
    return sessionStorage.getItem('BitDeviceInfo')
      ? JSON.parse(sessionStorage.getItem('BitDeviceInfo') as string)
      : {};
  }


  set IsEmulateMode(data: boolean) {
    sessionStorage.setItem('IsEmulateMode', String(data))
  }
  get IsEmulateMode(): boolean {
    const val = sessionStorage.getItem('IsEmulateMode');
    return (val === null || val === 'false') ? false : true;
  }


  set IsExcludeAppManager(data: boolean) {
    sessionStorage.setItem('IsExcludeAppManager', String(data))
  }
  get IsExcludeAppManager(): boolean {
    const val = sessionStorage.getItem('IsExcludeAppManager');
    return (val === null || val === 'false') ? false : true;
  }


  set EIOT(data: boolean) {
    sessionStorage.setItem('eiot', String(data))
  }
  get EIOT(): boolean {
    const val = sessionStorage.getItem('eiot');
    return (val === null || val === 'false') ? false : true;
  }


  set EIoTByPassAuth(data: boolean) {
    sessionStorage.setItem('EIoTByPassAuth', String(data))
  }
  get EIoTByPassAuth(): boolean {
    const val = sessionStorage.getItem('EIoTByPassAuth');
    return (val === null || val === 'false') ? false : true;
  }


  set EIoTAuth(data: IEIoTAuth) {
    sessionStorage.setItem('EIoTAuth', JSON.stringify(data));
  }
  get EIoTAuth(): IEIoTAuth {
    return sessionStorage.getItem('EIoTAuth')
      ? JSON.parse(sessionStorage.getItem('EIoTAuth') as string)
      : {};
  }
}

export const eiotSessionVarsService = new EIoTSessionVarsService()
